import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { TransactionService } from '../../core/services/transaction.service';
import { StudioService } from '../../core/services/studio.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-notification-suspend',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12" (ngSubmit)="save(notificationForm)">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">状態</label>
                <select class="form-control" [(ngModel)]="select.suspend" name="suspend" required>
                  <option value="">選択してください</option>
                  <option value="0">休会</option>
                  <option value="1">退会</option>
                </select>
              </div>
            </div>
            @if (select.suspend == '0') {
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">休会中区分コース</label>
                  <select class="form-control" [(ngModel)]="select.studioPlanInSuspend" name="studioPlanInSuspend" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (plan of studioPlansInSuspend; track plan.id) {
                      <option [ngValue]="plan">{{ plan.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">休会後区分コース</label>
                  <select class="form-control" [(ngModel)]="select.studioPlanAfterSuspend" name="studioPlanAfterSuspend" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (plan of studioPlans; track plan.id) {
                      <option [ngValue]="plan">{{ plan.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">休会期間</label>
                  <select class="form-control" [(ngModel)]="select.startDate" (ngModelChange)="select.endDate = null" name="startDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of startDateOptionsForSuspend; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                  <label class="w-100 col-form-label text-md-right"><span>から</span></label>
                </div>
                <div class="col-md-6">
                  <label class="col-form-label d-none d-md-inline-block">&nbsp;</label>
                  <select class="form-control" [(ngModel)]="select.endDate" name="endDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of filteredEndDatesForSuspend; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                  <label class="w-100 col-form-label text-md-right"><span>まで</span></label>
                </div>
              </div>
            }
            @if (select.suspend == '1') {
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">退会理由</label>
                  <input type="text" class="form-control" [(ngModel)]="select.reason" name="reason" required>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">最終利用月</label>
                  <select class="form-control" [(ngModel)]="select.endDate" name="endDateDisable" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of endDateOptionsForDisable; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">最終お支払日：
                    <span>{{ formatLastBillingMonth(select.endDate?.lastBillingMonth) }}</span>
                  </label>
                </div>
              </div>
            }
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || member?.status != 0"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationSuspendComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private transactionService = inject(TransactionService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);

  memberId!: number;
  member: any = null;
  studioPlans: any[] = [];
  startDateOptionsForSuspend: any[] = [];
  endDateOptionsForSuspend: any[] = [];
  endDateOptionsForDisable: any[] = [];
  select: any = { suspend: '', studioPlanInSuspend: null, studioPlanAfterSuspend: null, startDate: null, endDate: null, reason: '' };
  saving = false;
  completed = false;

  private batchDay = 11;

  get studioPlansInSuspend(): any[] {
    return this.studioPlans.filter(p => p.studioPlanTypeId === 5);
  }

  get filteredEndDatesForSuspend(): any[] {
    if (!this.select.startDate) return [];
    const n = this.select.startDate.number;
    return this.endDateOptionsForSuspend.filter(x => x.number >= n && x.number < n + 6);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    const now = new JstDate();
    this.member = await this.memberService.getOne(this.memberId);
    this.startDateOptionsForSuspend = this.getStartDateOptionsForSuspend(now);
    this.endDateOptionsForSuspend = this.getEndDateOptionsForSuspend(now);
    this.endDateOptionsForDisable = this.getEndDateOptionsForDisable(now);
    if (this.member?.studio?.id) {
      const studio: any = await this.studioService.list(this.member.studio.id);
      this.studioPlans = studio?.studioPlans ?? [];
    }
  }

  private getStartDateOptionsForSuspend(now: Date): any[] {
    const isAfter = now.getDate() >= this.batchDay;
    const p = isAfter ? 2 : 1;
    return Array.from({ length: 4 }, (_, i) => {
      const d = new JstDate(now.getFullYear(), now.getMonth() + p + i, 1);
      return {
        id: d.getFullYear() + '-' + (d.getMonth() + 1),
        name: `${d.getFullYear()}年${('0' + (d.getMonth() + 1)).slice(-2)}月`,
        date: d,
        number: i,
      };
    });
  }

  private getEndDateOptionsForSuspend(now: Date): any[] {
    const isAfter = now.getDate() >= this.batchDay;
    const p = isAfter ? 2 : 1;
    return Array.from({ length: 9 }, (_, i) => {
      const d = new JstDate(now.getFullYear(), now.getMonth() + p + i + 1, 0);
      return {
        id: d.getFullYear() + '-' + (d.getMonth() + 1),
        name: `${d.getFullYear()}年${('0' + (d.getMonth() + 1)).slice(-2)}月末`,
        date: d,
        number: i,
      };
    });
  }

  private getEndDateOptionsForDisable(now: Date): any[] {
    const endDateModify = this.batchDay <= now.getDate() ? 1 : 0;
    const billingMonthModify = Number(this.member?.payment?.paymentMethod ?? 0);
    return Array.from({ length: 4 }, (_, i) => {
      const d = new JstDate(now.getFullYear(), now.getMonth() + i + 1 + endDateModify, 0);
      return {
        id: d.getFullYear() + '-' + (d.getMonth() + 1),
        name: `${d.getFullYear()}年${('0' + (d.getMonth() + 1)).slice(-2)}月`,
        date: d,
        lastBillingMonth: new JstDate(d.getFullYear(), d.getMonth() - 1 + billingMonthModify),
      };
    });
  }

  formatLastBillingMonth(date: Date | undefined): string {
    if (!date) return '';
    const d = new JstDate(date);
    const y = d.getFullYear();
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
    if (this.member?.payment?.paymentMethod == 0) {
      return `${y}年${m}月末`;
    }
    const day = ('0' + d.getDate()).slice(-2);
    return `${y}年${m}月${day}日`;
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed || this.member?.status != 0) return;
    this.saving = true;
    const now = new JstDate();
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
      requestType: this.select.suspend === '0' ? 4 : 5,
    };
    if (json.requestType === 4) {
      json.startDate = this.select.startDate?.date;
      json.endDate = this.select.endDate?.date;
      json.beforeStudioPlanId = this.select.studioPlanAfterSuspend?.id;
      json.afterStudioPlanId = this.select.studioPlanInSuspend?.id;
      json.originalStudioPlanId = this.member.studioPlan?.id;
    }
    if (json.requestType === 5) {
      json.endDate = this.select.endDate?.date;
      json.note = this.select.reason;
    }
    try {
      const result = await this.notificationService.upsert(json);
      if (!result) {
        this.showFeedback('danger', '諸届申請を更新できませんでした');
        return;
      }
      this.completed = true;
      this.resetInputs(form);
      this.showFeedback('success', '諸届申請を更新しました');
    } finally {
      this.saving = false;
    }
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = { suspend: '', studioPlanInSuspend: null, studioPlanAfterSuspend: null, startDate: null, endDate: null, reason: '' };
    form?.resetForm({
      suspend: '',
      studioPlanInSuspend: null,
      studioPlanAfterSuspend: null,
      startDate: null,
      endDate: null,
      endDateDisable: null,
      reason: '',
    });
  }
  private refreshClockDates(): void {
    const now = new JstDate();
    this.startDateOptionsForSuspend = this.getStartDateOptionsForSuspend(now);
    this.endDateOptionsForSuspend = this.getEndDateOptionsForSuspend(now);
    this.endDateOptionsForDisable = this.getEndDateOptionsForDisable(now);
    this.select.startDate = this.select.endDate = null;
  }

}
